var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:("img  " + _vm.styles),style:(_vm.cssVars),attrs:{"src":_vm.imgSrc,"alt":(_vm.alt + " image")},on:{"error":_vm.setDefaultImg,"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }